import { Box, Text } from '@radix-ui/themes'
import { Ops } from '@willie/schemas'
import { FieldShell } from '~/components/FieldShell'
import { profileAssembly } from '../assembly'
import { SkuLinesTable } from './SkuLinesTable'
import { MISSING_ASSEMBLY_PROFILE_DETAIL } from '../constants'

interface AssemblyProfileSectionProps {
  profile: Parameters<typeof profileAssembly>[0]
}

const AssemblyProfileContent = ({ profile }: AssemblyProfileSectionProps) => {
  const assembly = profileAssembly(profile)
  if (assembly.kind === 'not-applicable') {
    return (
      <Text size="2" color="gray">
        No assembly profile needed: only Efento orders are built from SKUs.
      </Text>
    )
  }
  if (assembly.kind === 'missing') {
    return (
      <Text size="2" color="orange">
        {MISSING_ASSEMBLY_PROFILE_DETAIL}
      </Text>
    )
  }

  return (
    <Box>
      <Text size="2" weight="medium" className="font-mono">
        {assembly.assemblyProfile}
      </Text>
      <SkuLinesTable lines={Ops.InstallationProfileSkus.assemblyProfileSkuLines(assembly.assemblyProfile)} />
    </Box>
  )
}

export const AssemblyProfileSection = ({ profile }: AssemblyProfileSectionProps) => (
  <FieldShell
    label="Assembly profile"
    hint={
      <Text size="1" color="gray">
        Assembly profiles and SKUs are defined in code and cannot be edited here.
      </Text>
    }
  >
    <AssemblyProfileContent profile={profile} />
  </FieldShell>
)
